import { getFetch } from '../fetch';
import { apiConfig } from '../config';
import { CourseContainerGroup } from '../../../typings';

export interface CourseContainerGroups {
    [x: string]: CourseContainerGroup[];
}

export interface GetCourseContainerQueryParams {
    slugs?: string[];
}

export function getCourseContainerGroups(params: GetCourseContainerQueryParams): Promise<CourseContainerGroups> {
    const { apiGetCourseContainerGroups } = apiConfig.getStaticUrls();

    return getFetch(apiGetCourseContainerGroups, { slugs: params?.slugs?.join(',') });
}
